<template>
  <b-modal
    id="inactivityModal"
    content-class="menu-bg-blue-transparent-modal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
  >
    <span style="font-size: 150%">
      Your session will expire in {{ this.timeBeforeLogout }} seconds.
      Interact with this page to remain logged in.
    </span>
  </b-modal>
</template>

<script>
export default {
  name: 'MMP_InactivityWarning',
  props: ['timeBeforeLogout']
}
</script>
